import { Accessor, UpdateParameters } from '@deck.gl/core';
import { Texture } from '@luma.gl/core';
import { positionTextureModule, positionTextureModuleName } from '../../modules/coast-position-texture';
import { HidableMultiIconLayer } from './hidable-multi-icon-layer';

export class AnimatedTagMultiIconLayer<TData> extends HidableMultiIconLayer<
    TData,
    {
        getId: Accessor<TData, number>;
        positionTexture: Texture | null;
    }
> {
    getShaders() {
        const shaders = super.getShaders();
        return {
            ...shaders,
            modules: [...shaders.modules, positionTextureModule]
        };
    }

    initializeState() {
        super.initializeState();
        this.getAttributeManager()!.remove(['instancePositions']);
        this.getAttributeManager()!.addInstanced({
            instanceId: {
                size: 1,
                type: 'uint32',
                accessor: 'getId'
            }
        });
    }

    updateState(params: UpdateParameters<this>): void {
        super.updateState(params);
        if (params.changeFlags.propsChanged) {
            this.state.model?.shaderInputs.setProps({
                [positionTextureModuleName]: this.props
            });
        }
    }
}
